import { WavesArrowLeftIcon } from './WavesArrowLeftIcon';

/**
 * author: Michael Irigoyen
 * id FC4A7A1E-A32E-432E-8EB3-79FFA3E012C1
 * name waves-arrow-left
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/waves-arrow-left.svg
 * tags
 * - Nature 
 * - Weather 
 */
export const TideInIcon = WavesArrowLeftIcon;
export default TideInIcon